export default __webpack_public_path__ + "static/media/logo_ma192.80a62c8a.png";